module.exports = __webpack_public_path__ + "static/img/img17.a1dc350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aifv/img17.png
// module id = 1o1+
// module chunks = 1